// src/modules/permission/services/useUpdatePermissions.ts
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useAccessToken } from '@/features/auth/state/auth'
import api from '@/lib/api'

export function useUpdatePermissions(id_user: string | undefined) {
  const queryClient = useQueryClient()
  const token = useAccessToken()

  return useMutation({
    // mutationFn recebe diretamente o objeto de permissões
    mutationFn: async (newPermissions: any) => {
      console.log(newPermissions)
      const response = await api.put(`/permissions`, newPermissions, {
        headers: { Authorization: `Bearer ${token}` }
      })
      return response.data
    },
    onSuccess: () => {
      // invalida só a query de permissions deste usuário
      queryClient.invalidateQueries({ queryKey: ['permissions', id_user] })
    }
  })
}
